<template>
  <div class="tab">
    <router-link tag="div" class="tab-item" to="/dataDisplay/businessData">
      <span class="businessImg"></span>
      <span class="tab-link">营业数据</span>
    </router-link>
    <router-link tag="div" class="tab-item" to="/dataDisplay/dishData">
      <span class="dishImg"></span>
      <span class="tab-link">菜品数据</span>
    </router-link>
    <router-link tag="div" class="tab-item" to="/dataDisplay/userSetting">
      <span class="userSettingImg"></span>
      <span class="tab-link">用户设置</span>
    </router-link>
  </div>
</template>

<script>
  export default {}
</script>

<style scoped >
  .tab{
    position: fixed;
    display: flex;
    bottom: 0;
    height: 0.98rem;
    font-size: 14px;
    background-color: #ffffff;
    display: -webkit-flex; 
    align-items:center;
    box-shadow: 0 -1px 10px #ccc;
  }    
  .tab-item{
    flex: 1;
    text-align: center;
  }
  .tab-link{
   color: #999999;
    display: block;
  }       
  .router-link-active .tab-link{    
     color: #ff776d;
  }  
  .businessImg{  
    width: 0.44rem;
    height: 0.44rem;
    display: inline-block;
    background: url('~common/image/businessImg.png');
    background-size: 100% 100%;
  } 
  .dishImg{
    width: 0.44rem;
    height: 0.44rem;
    display: inline-block;
    background: url('~common/image/dishImg.png');
    background-size: 100% 100%;
  }
  .userSettingImg{
    width: 0.44rem;
    height: 0.44rem;
    display: inline-block;
    background: url('~common/image/userSetting.png');
    background-size: 100% 100%;
  }
  .router-link-active .businessImg{ 
    width: 0.44rem;
    height: 0.44rem;   
    background: url('~common/image/businessImgSelect.png');
    background-size: 100% 100%;
  }
  .router-link-active .dishImg{ 
    width: 0.44rem;
    height: 0.44rem;   
    background: url('~common/image/dishImgSelect.png');
    background-size: 100% 100%;
  }  
  .router-link-active .userSettingImg{ 
    width: 0.44rem;
    height: 0.44rem;   
    background: url('~common/image/userSettingSelect.png');
    background-size: 100% 100%;
  }              
</style>


// WEBPACK FOOTER //
// src/components/tab.vue